import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';
import { computed } from 'vue';

export const useSurfActions = () => {
	const { config, loadModuleConfig } = useModuleConfig();

	const initConfig = async () => {
		await loadModuleConfig('contact_information');
	};

	const iconMap = {
		'appointment': 'surf_appointment',
		'leave_word': 'surf_feedback',
		'message_subscription': 'surf_message'
	};
	const actions = computed(() => {
		return (config.value.tab || [])
			.filter(item => item.isPublish)
			.sort((a, b) => a.sort - b.sort)
			.map(item => {
				return {
					label: item.name,
					id: item.id,
					icon: iconMap[item.id]
				};
			});
	});

	return {
		initConfig,
		actions
	};
};
